export default {"src":"/_next/static/media/undraw_dreamer.bc0406f4.svg","height":752,"width":1018,"blurWidth":0,"blurHeight":0};